import 'whatwg-fetch'
import Prismic from 'prismic-javascript'
import PrismicConfig from '../../config/prismic'
import { FETCH_PRISMIC, ACTIVE_DOC, PRISMIC_DATA } from '../constants'

const refreshToolbar = () => {
  const maybeCurrentExperiment = this.api.currentExperiment();
  if (maybeCurrentExperiment) {
    window.PrismicToolbar.startExperiment(maybeCurrentExperiment.googleId());
  }
  window.PrismicToolbar.setup(PrismicConfig.apiEndpoint);
}


export const fetchPrismic = locale => dispatch => {
  const accessToken = PrismicConfig.accessToken
  Prismic.api(PrismicConfig.apiEndpoint, { accessToken }).then(api => ({
    api,
    endpoint: PrismicConfig.apiEndpoint,
    accessToken,
    linkResolver: PrismicConfig.linkResolver,
    toolbar: refreshToolbar,
    lang: locale
  })).then((prismicCtx) => {
    dispatch({
      type: FETCH_PRISMIC,
      payload: prismicCtx
    })
  }).catch((err) => {
    console.error(`Cannot contact the API, check your prismic configuration:\n${err}`)
  })
}

export const getActiveDoc = doc => {
  return {
    type: ACTIVE_DOC,
    doc: doc
  }
}

export const getPrismicData = doc => {
  return {
    type: PRISMIC_DATA,
    payload: doc
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/prismicActions.js